import 'react-multi-carousel/lib/styles.css'

import React from 'react'

import classes from './Vacancies.module.scss'
import { Button } from 'shared/components'

import vacancyImg1 from 'assets/images/aboutUsPage/HR_h.png'
import { useWindowSize } from 'shared/hooks/useWindowSize'

export const Vacancies = (): JSX.Element => {
  const { isMobile } = useWindowSize()
  const breakLine = isMobile ? ' ' : <br />

  return (
    <div className={classes.wrapper}>
      <div className={`${classes.container} container`}>
        <div
          className={`${classes.desc} reveal-from-bottom-medium`}
          data-reveal-delay={50}
        >
          <h2
            className={`${classes.title} second-title  reveal-from-bottom-medium`}
          >
            Открытые
            <br />
            вакансии
          </h2>
          <p>
            Трудоустройство в KION - это шанс{breakLine}поработать в одной из
            самых увлеченных{breakLine}и мотивированных команд на рынке медиа.
          </p>
          <a href="https://job.mts.ru" target="_blank" rel="noreferrer">
            <Button>
              <span className="col-xs-hidden">Смотреть вакансии</span>
              <span className="col-xs-visible">Смотреть вакансии</span>
            </Button>
          </a>
          <img
            className={classes['vacancies__image--big']}
            src={vacancyImg1}
            alt="vacancies"
          ></img>
        </div>
      </div>
    </div>
  )
}
